import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { DispatchType, IRootState } from '.'

// export const useAppSelector = useSelector
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector
export const useAppDispatch: () => DispatchType = useDispatch
